export enum ContactToShowOptions {
  AddressName = 'Address name',
  SoContact = 'Sales Order contact',
}

export enum OrderNumberOptions {
  CustomerPoNumber = 'Customer PO Number',
  SoNumber = 'SO number',
}
